'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    { createStore } = require('../utils/StoreUtils');

var _image = null,
    _sectionType = null;

var LightboxStore = createStore({
  isActive() {
    return !!_image;
  },

  getActiveImageUuid() {
    if (this.isActive()) {
      return _image.uuid;
    }
  },

  getActiveSectionType() {
    if (this.isActive()) {
      return _sectionType;
    }
  }
});

AppDispatcher.register(function (payload) {
  var action = payload.action;

  switch (action.type) {
  case ActionTypes.ENTER_LIGHTBOX:
    _image = action.image;
    _sectionType = action.sectionType;
    LightboxStore.emitChange();
    break;

  case ActionTypes.LEAVE_LIGHTBOX:
    _image = null;
    _sectionType = null;
    LightboxStore.emitChange();
    break;
  }
});

module.exports = LightboxStore;


/** WEBPACK FOOTER **
 ** ./stores/LightboxStore.js
 **/